import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ColorGradingFilter } from 'js/src/client';

// Define a type for the slice state
export interface ColorGradingState {
    colorGradingFilters: ColorGradingFilter[];
    isColorGradingFiltersLoading?: boolean;
    isColorGradingFiltersError?: boolean;
}

export const MONO_FILTER_TEXTURE_URL =
    'https://storage.googleapis.com/lumen5-prod-colorgrading/texture-Mono-ygvzvn.png';

// Define the initial state using that type
const initialState: ColorGradingState = {
    colorGradingFilters: [],
};

export const colorGradingSlice = createSlice({
    name: 'colorGrading',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        storeColorGradingFilters: (
            state,
            action: PayloadAction<{
                colorGradingFilters: ColorGradingFilter[];
            }>,
        ) => {
            state.colorGradingFilters = action.payload.colorGradingFilters;
        },
        setIsColorGradingFiltersLoading: (state, action: PayloadAction<boolean>) => {
            state.isColorGradingFiltersLoading = action.payload;
        },
        setIsColorGradingFiltersError: (state, action: PayloadAction<boolean>) => {
            state.isColorGradingFiltersError = action.payload;
        },
    },
});

export const {
    storeColorGradingFilters,
    setIsColorGradingFiltersLoading,
    setIsColorGradingFiltersError,
} = colorGradingSlice.actions;
export const colorGradingActionTypes = Object.values(colorGradingSlice.actions).map(
    (action) => action.type,
);

export const colorGradingReducer = colorGradingSlice.reducer;
